import {
    GET_TICKETS,
    SUCCESS_GET_TICKETS,
    FAILED_GET_TICKETS,
    SUCCESS_IS_CONNECTED,
    FAILED_IS_CONNECTED,
    SUCCESS_CREATE_TICKET,
    FAILED_CREATE_TICKET,
    SUCCESS_ADD_COMMENT,
    FAILED_ADD_COMMENT,
    SUCCESS_GET_CLIENT_NOTIFY_HISTORIES,
    FAILED_GET_CLIENT_NOTIFY_HISTORIES,
    GET_OPENED_TICKET_COUNT_SUCCESS,
    GET_OPENED_TICKET_COUNT_FAILED,
    GET_NOTIFICATION_COUNT_SUCCESS,
    GET_NOTIFICATION_COUNT_FAILED,
    GET_NOTIFICATIONS,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAILED,
    MARK_NOTIFICATION_AS_READ,
    MARK_NOTIFICATION_AS_READ_SUCCESS,
    MARK_NOTIFICATION_AS_READ_FAILED,
    MARK_ALL_NOTIFICATIONS_AS_READ,
    MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
    MARK_ALL_NOTIFICATIONS_AS_READ_FAILED,
    CLEAR_ALL_READ_NOTIFICATIONS_SUCCESS,
    CLEAR_ALL_READ_NOTIFICATIONS_FAILED,
    REMOVE_TICKET_CC_SUCCESS,
    REMOVE_TICKET_CC_FAILED,
} from '../constants/zendeskConstants';

const initialState = {
    connectStatus: null,
    currentZendeskUser: null,

    /*
     * Zendesk tickets
     */
    tickets: [],
    isLoadingTickets: false,
    ticketsError: null,

    /*
     * Ticket creation
     */
    createTicketError: null,

    /*
     * Ticket comments
     */
    addCommentError: null,

    /*
     * Client notification history
     */
    notifyHistories: [],

    loading: false,
    errorMessage: '',

    /*
     * Opened ticket count
     */
    openedTicketCount: 0,

    /*
     * Notifications
     */
    notificationCount: 0,
    notifications: [],
    isLoadingNotifications: false,

    /*
     * Remove ticket CC
     */
    isRemovingTicketCc: false,
    removeTicketCcError: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_IS_CONNECTED:
            return {
                ...state,
                connectStatus: action.payload.connectStatus,
                currentZendeskUser: action.payload.currentZendeskUser || null,
                errorMessage: '',
            };

        case FAILED_IS_CONNECTED:
            return {
                ...state,
                connectStatus: false,
                currentZendeskUser: null,
                errorMessage: '',
            };

        /*
         * Zendesk tickets
         */
        case GET_TICKETS:
            return {
                ...state,
                isLoadingTickets: true,
                ticketsError: null,
            };

        case SUCCESS_GET_TICKETS:
            return {
                ...state,
                tickets: action.payload.tickets || [],
                isLoadingTickets: false,
                ticketsError: null,
            };

        case FAILED_GET_TICKETS:
            return {
                ...state,
                isLoadingTickets: false,
                ticketsError: action.payload,
            };

        /*
         * Add ticket comment
         */
        case SUCCESS_ADD_COMMENT:
            return {
                ...state,
                tickets: state.tickets.map((ticket) =>
                    ticket.id === action.payload.ticket.id
                        ? action.payload.ticket
                        : ticket
                ),
                addCommentError: null,
            };

        case FAILED_ADD_COMMENT:
            return {
                ...state,
                addCommentError: action.payload,
            };

        /*
         * Create ticket
         */
        case SUCCESS_CREATE_TICKET:
            return {
                ...state,
                tickets: [
                    action.payload.ticket,
                    ...state.tickets,
                ],
                createTicketError: null,
            };

        case FAILED_CREATE_TICKET:
            return {
                ...state,
                createTicketError: action.payload,
            };

        /*
         * Client notification history
         */
        case SUCCESS_GET_CLIENT_NOTIFY_HISTORIES:
            return {
                ...state,
                notifyHistories: action.payload || [],
                errorMessage: '',
            };

        case FAILED_GET_CLIENT_NOTIFY_HISTORIES:
            return {
                ...state,
                notifyHistories: [],
                errorMessage: action.payload,
            };

        /*
         * Opened ticket count
         */
        case GET_OPENED_TICKET_COUNT_SUCCESS:
            return {
                ...state,
                openedTicketCount: action.payload.opened_ticket_count,
            };

        case GET_OPENED_TICKET_COUNT_FAILED:
            return {
                ...state,
                openedTicketCount: 0,
            };

        /*
         * Notifications
         */
        case GET_NOTIFICATION_COUNT_SUCCESS:
            return {
                ...state,
                notificationCount: action.payload.count,
            };

        case GET_NOTIFICATION_COUNT_FAILED:
            return {
                ...state,
                notificationCount: 0,
            };

        case GET_NOTIFICATIONS:
            return {
                ...state,
                isLoadingNotifications: true,
            };

        case GET_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: action.payload.notifications || [],
                isLoadingNotifications: false,
            };

        case GET_NOTIFICATIONS_FAILED:
            return {
                ...state,
                isLoadingNotifications: false,
            };

        /*
         * Mark single notification as read
         */
        case MARK_NOTIFICATION_AS_READ:
            return {
                ...state,
            };

        case MARK_NOTIFICATION_AS_READ_SUCCESS:
            return {
                ...state,
                notifications: state.notifications.map(
                    notification => (
                        notification.id === action.payload.id
                            ? {
                                ...notification,
                                is_read: true,
                                read_at: action.payload.read_at,
                            }
                            : notification
                    )
                ),
            };

        case MARK_NOTIFICATION_AS_READ_FAILED:
            return {
                ...state,
                errorMessage: action.payload,
            };

        /*
         * Mark all notifications as read
         */
        case MARK_ALL_NOTIFICATIONS_AS_READ:
            return {
                ...state,
            };

        case MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS:
            return {
                ...state,
                notifications: state.notifications.map(
                    notification => ({
                        ...notification,
                        is_read: true,
                    })
                ),
            };

        case MARK_ALL_NOTIFICATIONS_AS_READ_FAILED:
            return {
                ...state,
                errorMessage: action.payload,
            };

        case CLEAR_ALL_READ_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: state.notifications.filter(
                    notification => !notification.is_read
                ),
            };

        case CLEAR_ALL_READ_NOTIFICATIONS_FAILED:
            return {
                ...state,
            };

        /*
         * Remove ticket CC
         */
        case REMOVE_TICKET_CC_SUCCESS:
            return {
                ...state,
                tickets: state.tickets.map(ticket =>
                    ticket.id === action.payload.id
                        ? {
                            ...ticket,
                            email_ccs: action.payload.email_ccs,
                        }
                        : ticket
                ),
                selectedTicket:
                    state.selectedTicket &&
                    state.selectedTicket.id === action.payload.id
                        ? {
                            ...state.selectedTicket,
                            email_ccs: action.payload.email_ccs,
                        }
                        : state.selectedTicket,
                isRemovingTicketCc: false,
                removeTicketCcError: null,
            };

        case REMOVE_TICKET_CC_FAILED:
            return {
                ...state,
                isRemovingTicketCc: false,
                removeTicketCcError: action.payload,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/state/reducers/zendeskReducer.js